import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { TracciaNavigazione } from './common/navigazione';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'react-hot-toast'; // NEW: Toast system for alerts replacement

import './App.css';
import './print.css';
import './assets/css/custom-fonts.css'; // Import del CSS per i font personalizzati
import DashboardLayout from './layouts/DashboardLayout';
import { AuthProvider } from './context/AuthContext'; // NEW IMPORT
import { SidebarProvider } from './context/SidebarContext'; // NEW IMPORT
import Login from './pages/Login'; // NEW IMPORT
import ProtectedRoute from './components/ProtectedRoute'; // NEW IMPORT

// Importa i componenti delle pagine
import Home from './pages/Home';
import ClientiList from './pages/ClientiList';
import FornitoriList from './pages/FornitoriList';
import FilmList from './pages/FilmList';
import CorrieriList from './pages/CorrieriList';
import BancheList from './pages/BancheList';
import ContiLayout from './components/conti/ContiLayout';
import RapportiBancari from './pages/conti/RapportiBancari';
import PianoConti from './pages/conti/PianoConti';
import Movimenti from './pages/conti/Movimenti';
import BilancioConti from './pages/conti/Bilancio';
import Finanziamenti from './pages/conti/Finanziamenti';
import OrdiniList from './pages/OrdiniList';
import MovimentiMagazzinoList from './pages/MovimentiMagazzinoList';
import CaricoMagazzino from './pages/CaricoMagazzino';

import DatiAzienda from './pages/DatiAzienda';
import BackupDati from './pages/BackupDati';

// Importa i componenti dei form
import NuovoFilm from './components/forms/NuovoFilm';
import NuovoFornitore from './components/forms/NuovoFornitore';
import NuovoCorriere from './components/forms/NuovoCorriere';
import NuovoBanca from './components/forms/NuovoBanca';
import NuovoOrdine from './components/forms/NuovoOrdine';
import FilmImport from './pages/FilmImport';
import ClientiImport from './pages/ClientiImport';
import FornitoriImport from './pages/FornitoriImport';
import FilmImportTMDB from './pages/FilmImportTMDB';
import FilmImportCecchiGori from './pages/FilmImportCecchiGori';
import ListinoImport from './pages/ListinoImport';
import MusicaImportMusicBrainz from './pages/MusicaImportMusicBrainz';
import NuovaMusica from './pages/NuovaMusica';
import MusicaImport from './pages/MusicaImport';
import ClientiDetail from './pages/ClientiDetail';
import ClientiEdit from './pages/ClientiEdit';
import ClientiPrint from './common/ClientiPrint';

import FornitoriDetail from './pages/FornitoriDetail';
import FornitoriEdit from './pages/FornitoriEdit';
import FornitoriPrint from './common/FornitoriPrint';
import FilmDetail from './pages/FilmDetail';
import FilmEdit from './pages/FilmEdit';
import FilmPrint from './common/FilmPrint';

import MusicaList from './pages/MusicaList';
import MusicaDetail from './pages/MusicaDetail';
import MusicaEdit from './pages/MusicaEdit';
import MusicaPrint from './common/MusicaPrint';

import CorrieriDetail from './pages/CorrieriDetail';
import CorrieriEdit from './pages/CorrieriEdit';
import CorrieriPrint from './common/CorrieriPrint';

import BancheDetail from './pages/BancheDetail';
import BancheEdit from './pages/BancheEdit';
import BanchePrint from './common/BanchePrint';

import OrdiniDetail from './pages/OrdiniDetail';
import OrdiniEdit from './pages/OrdiniEdit';
import OrdiniPrint from './common/OrdiniPrint';
import ListaEvasionePrint from './common/ListaEvasionePrint';
import ServiziList from './pages/ServiziList';
import PreventiviList from './pages/PreventiviList';
import RichiesteRiversamenti from './pages/RichiesteRiversamenti';
import ServiziDetail from './pages/ServiziDetail';
import ServiziEdit from './pages/ServiziEdit';
import ServiziPrint from './common/ServiziPrint';
import CollectibleList from './pages/CollectibleList';
import CollectibleEdit from './pages/CollectibleEdit';
import CollectibleDetail from './pages/CollectibleDetail';

import PreventivoDetail from './pages/PreventivoDetail';
import PreventivoEdit from './pages/PreventivoEdit';
import NuovoPreventivo from './components/forms/NuovoPreventivo';

import CanoniMarketplaceList from './pages/CanoniMarketplaceList';
import NuovoCanoneMarketplace from './pages/NuovoCanoneMarketplace';
import EditCanoneMarketplace from './pages/EditCanoneMarketplace';
import CanoniMarketplaceDetail from './pages/CanoniMarketplaceDetail';
import CanoniMarketplacePrint from './common/CanoniMarketplacePrint';
import LayoutList from './components/LayoutEditor/LayoutList';
import LayoutEditor from './components/LayoutEditor/LayoutEditor';
import AdminPage from './pages/AdminPage';
import FatturePassiveList from './pages/FatturePassiveList';
import FattureEmesseList from './pages/FattureEmesseList';
import OrdiniDaFatturareList from './pages/OrdiniDaFatturareList';
import RicevuteList from './pages/contabilita/RicevuteList';
import RegistroCorrispettivi from './pages/contabilita/RegistroCorrispettivi';
import LiquidazioneIva from './pages/contabilita/LiquidazioneIva';
import Scadenzario from './pages/contabilita/Scadenzario';
import PrimaNota from './pages/contabilita/PrimaNota';
import ReportAnnuale from './pages/contabilita/ReportAnnuale';
import RegistroBeniAmmortizzabili from './pages/contabilita/RegistroBeniAmmortizzabili';
import ContabilitaDashboard from './pages/ContabilitaDashboard';
import EcommerceDashboard from './pages/EcommerceDashboard';
import NuovaScrittura from './pages/NuovaScrittura';
import ProdottiIBS from './pages/ProdottiIBS'; // New import
import IBSMessagesPage from './pages/IBSMessagesPage';
import ErroriOfferteIBS from './pages/ErroriOfferteIBS';
import ReclamiIBS from './pages/ReclamiIBS';
import RicarichiIBSPage from './pages/RicarichiIBSPage';
import SpedizioneSitoPage from './pages/SpedizioneSitoPage';
import RepricingIBSPage from './pages/RepricingIBSPage';
import RepricingDashboardPage from './pages/RepricingDashboardPage';
import IBSPaymentsDashboard from './pages/IBSPaymentsDashboard'; // NEW: Dashboard pagamenti IBS
import OrdiniNotificheConsegna from './pages/OrdiniNotificheConsegna';
import CalendarioPage from './pages/CalendarioPage';
import NuovoEventoCalendario from './pages/NuovoEventoCalendario';
import AttivitaPage from './pages/AttivitaPage';
import NuovaAttivitaPage from './pages/NuovaAttivitaPage';
import ModificaAttivitaPage from './pages/ModificaAttivitaPage';
import StandardEventsPage from './pages/StandardEventsPage';
import EmailTemplateList from './components/email_templates/EmailTemplateList';
import EmailTemplateEdit from './components/email_templates/EmailTemplateEdit';
import EmailSchedulateManagement from './components/EmailSchedulateManagement'; // Gestione Email Schedulate
import FireflyConfig from './pages/FireflyConfig'; // AGGIUNTO
import PromozioniList from './pages/PromozioniList'; // AGGIUNTO
import PromozioneEdit from './pages/PromozioneEdit'; // AGGIUNTO
import CataloghiList from './pages/CataloghiList'; // Cataloghi PDF
import CatalogoEdit from './pages/CatalogoEdit'; // Cataloghi PDF Edit
import CopertineDvdList from './pages/CopertineDvdList'; // Copertine DVD da elenco film
import CopertineDvdLotto from './pages/CopertineDvdLotto'; // Copertine DVD: controllo di un lotto
import CodiciScontoList from './pages/CodiciScontoList'; // Codici Sconto
import CodiciScontoEdit from './pages/CodiciScontoEdit'; // Codici Sconto Edit
import CodiciScontoPrint from './pages/CodiciScontoPrint'; // Stampa Codici Sconto
import CodiciOmaggioPrint from './pages/CodiciOmaggioPrint'; // Stampa biglietti codici omaggio (2 per A4)
import PuntiFedeltaConfig from './pages/PuntiFedeltaConfig'; // Configurazione Punti Fedeltà
import PuntiFedeltaManagement from './pages/PuntiFedeltaManagement'; // Gestione Punti Fedeltà
import RecensioniManagement from './pages/RecensioniManagement'; // Gestione Recensioni
import WishlistManagement from './pages/WishlistManagement'; // Gestione Wishlist
import ValutazioniServizioManagement from './pages/ValutazioniServizioManagement'; // Gestione Valutazioni Servizio
import AuditLogsPage from './pages/AuditLogsPage'; // Pagina Log di Audit
import GestioneHomepage from './pages/GestioneHomepage'; // NUOVO: Gestione Layout Homepage
import UserManagement from './pages/UserManagement'; // NEW
import GestioneAbout from './pages/GestioneAbout';
import ContenutiRiversamenti from './pages/ContenutiRiversamenti';
import InventarioPage from './pages/InventarioPage'; // Inventario fisico
import CustodiePrelevatePage from './pages/CustodiePrelevatePage'; // Custodie riusate -> DVD in busta
import AbbandoniPage from './pages/AbbandoniPage'; // Pagamenti e carrelli abbandonati del sito

export function App() {
  return (
      <Router>
          <TracciaNavigazione />
          <AuthProvider>
              <SidebarProvider>
              <ToastContainer />
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                  success: {
                    style: {
                      background: '#10b981',
                    },
                  },
                  error: {
                    style: {
                      background: '#ef4444',
                    },
                  },
                }}
              />
              <DashboardLayout>
                  <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="*" element={
                          <ProtectedRoute>
                              <Routes>
                                  <Route path="/" element={<Home />} />
                                  <Route path="/clienti" element={<ClientiList />} />
                                  <Route path="/clienti/:id" element={<ClientiDetail />} />
                                  <Route path="/clienti/new" element={<ClientiEdit />} />
                                  <Route path="/clienti/edit/:id" element={<ClientiEdit />} />
                                  <Route path="/clienti/print/:id" element={<ClientiPrint />} />

                                  <Route path="/fornitori" element={<FornitoriList />} />
                                  <Route path="/fornitori/:id" element={<FornitoriDetail />} />
                                  <Route path="/fornitori/edit/:id" element={<FornitoriEdit />} />
                                  <Route path="/fornitori/print/:id" element={<FornitoriPrint />} />

                                  <Route path="/film" element={<FilmList />} />
                                  <Route path="/film/:id" element={<FilmDetail />} />
                                  <Route path="/film/edit/:id" element={<FilmEdit />} />
                                  <Route path="/film/print/:id" element={<FilmPrint />} />

                                  <Route path="/musica" element={<MusicaList />} />
                                  <Route path="/musica/:id" element={<MusicaDetail />} />
                                  <Route path="/musica/edit/:id" element={<MusicaEdit />} />
                                  <Route path="/musica/print/:id" element={<MusicaPrint />} />

                                  <Route path="/corrieri" element={<CorrieriList />} />
                                  <Route path="/corrieri/:id" element={<CorrieriDetail />} />
                                  <Route path="/corrieri/edit/:id" element={<CorrieriEdit />} />
                                  <Route path="/corrieri/print/:id" element={<CorrieriPrint />} />

                                  <Route path="/banche" element={<BancheList />} />
                                  <Route path="/conti" element={<ContiLayout />}>
                                    <Route index element={<Navigate to="movimenti" replace />} />
                                    <Route path="movimenti" element={<Movimenti />} />
                                    <Route path="rapporti" element={<RapportiBancari />} />
                                    <Route path="piano" element={<PianoConti />} />
                                    <Route path="bilancio" element={<BilancioConti />} />
                                    <Route path="finanziamenti" element={<Finanziamenti />} />
                                  </Route>
                                  <Route path="/banche/:id" element={<BancheDetail />} />
                                  <Route path="/banche/edit/:id" element={<BancheEdit />} />
                                  <Route path="/banche/print/:id" element={<BanchePrint />} />

                                  <Route path="/canoni-marketplace" element={<CanoniMarketplaceList />} />
                                  <Route path="/canoni-marketplace/new" element={<NuovoCanoneMarketplace />} />
                                  <Route path="/canoni-marketplace/edit/:id" element={<EditCanoneMarketplace />} />
                                  <Route path="/canoni-marketplace/:id" element={<CanoniMarketplaceDetail />} />
                                  <Route path="/canoni-marketplace/print" element={<CanoniMarketplacePrint />} />

                                  <Route path="/contabilita/dashboard" element={<ContabilitaDashboard />} />
                                  <Route path="/ecommerce/dashboard" element={<EcommerceDashboard />} />
                                  <Route path="/contabilita/nuova-scrittura" element={<PrimaNota />} />
                                  <Route path="/contabilita/prima-nota" element={<PrimaNota />} />
                                  <Route path="/contabilita/report-annuale" element={<ReportAnnuale />} />
                                  <Route path="/contabilita/beni-ammortizzabili" element={<RegistroBeniAmmortizzabili />} />
                                  <Route path="/fatture-passive" element={<FatturePassiveList />} />
                                  <Route path="/fatture-emesse" element={<FattureEmesseList />} />
                                  <Route path="/ordini-da-gestire" element={<OrdiniDaFatturareList />} />
                                  <Route path="/ricevute" element={<RicevuteList />} />
                                  <Route path="/registro-corrispettivi" element={<RegistroCorrispettivi />} />
                                  <Route path="/contabilita/liquidazione-iva" element={<LiquidazioneIva />} />
                                  <Route path="/contabilita/scadenzario" element={<Scadenzario />} />
                                  <Route path="/accounting/config" element={<FireflyConfig />} />

                                  {/* Rotte per gli ordini */}
                                  <Route path="/ordini/abbandoni" element={<AbbandoniPage />} />
                                  <Route path="/ordini" element={<OrdiniList />} />
                                  <Route path="/ordini/:id" element={<OrdiniDetail />} />
                                  <Route path="/ordini/edit/:id" element={<OrdiniEdit />} />
                                  <Route path="/ordini/print/:id" element={<OrdiniPrint />} />
                                  <Route path="/ordini/lista-evasione/print" element={<ListaEvasionePrint />} />

                                  {/* Rotte per i preventivi */}
                                  <Route path="/preventivi" element={<PreventiviList />} />
                                  <Route path="/preventivi/riversamenti" element={<RichiesteRiversamenti />} />
                                  <Route path="/preventivi/:id" element={<PreventivoDetail />} />
                                  <Route path="/preventivi/edit/:id" element={<PreventivoEdit />} />
                                  <Route path="/preventivi/new" element={<NuovoPreventivo />} />

                                  <Route path="/servizi" element={<ServiziList />} />
                                  <Route path="/servizi/new" element={<ServiziEdit />} />
                                  <Route path="/nuovo/servizio" element={<ServiziEdit />} />
                                  <Route path="/servizi/:id" element={<ServiziDetail />} />
                                  <Route path="/servizi/edit/:id" element={<ServiziEdit />} />
                                  <Route path="/servizi/print/:id" element={<ServiziPrint />} />

                                  <Route path="/collectibles" element={<CollectibleList />} />
                                  <Route path="/collectibles/new" element={<CollectibleEdit />} />
                                  <Route path="/collectibles/edit/:id" element={<CollectibleEdit />} />
                                  <Route path="/collectibles/:id" element={<CollectibleDetail />} />
                                  <Route path="/movimenti-magazzino" element={<MovimentiMagazzinoList />} />
                                  <Route path="/magazzino/carico" element={<CaricoMagazzino />} />
                                  <Route path="/magazzino/inventario" element={<InventarioPage />} />
                                  <Route path="/magazzino/custodie" element={<CustodiePrelevatePage />} />

                                  {/* Rotte per il menu "Nuovo" e i form di inserimento */}
                                  <Route path="/nuovo/film" element={<NuovoFilm />} />
                                  <Route path="/nuovo/fornitore" element={<NuovoFornitore />} />
                                  <Route path="/nuovo/corriere" element={<NuovoCorriere />} />
                                  <Route path="/nuovo/banca" element={<NuovoBanca />} />
                                  <Route path="/nuovo/ordine" element={<NuovoOrdine />} />

                                  <Route path="/nuovo/film-import-tmdb" element={<FilmImportTMDB />} />
                                  <Route path="/nuovo/film/import" element={<FilmImport />} />
                                  <Route path="/nuovo/film-import-cecchi-gori" element={<FilmImportCecchiGori />} />
                                  <Route path="/nuovo/film-import-listino" element={<ListinoImport />} />
                                  <Route path="/nuovo/musica/import" element={<MusicaImport />} />
                                  <Route path="/musica/nuovo" element={<NuovaMusica />} />
                                  <Route path="/film/import-tmdb" element={<FilmImportTMDB />} />
                                  <Route path="/musica/import-musicbrainz" element={<MusicaImportMusicBrainz />} />
                                  <Route path="/clienti/import" element={<ClientiImport />} />
                                  <Route path="/fornitori/import" element={<FornitoriImport />} />
                                  <Route path="/impostazioni/dati-azienda" element={<DatiAzienda />} />
                                  <Route path="/impostazioni/spedizione-sito" element={<SpedizioneSitoPage />} />
                                  <Route path="/impostazioni/backup-dati" element={<BackupDati />} />
                                  <Route path="/impostazioni/titoli-evento-standard" element={<StandardEventsPage />} />
                                  <Route path="/calendario" element={<CalendarioPage />} />
                                  <Route path="/calendario/nuovo" element={<NuovoEventoCalendario />} />
                                  <Route path="/attivita" element={<AttivitaPage />} />
                                  <Route path="/attivita/nuovo" element={<NuovaAttivitaPage />} />
                                  <Route path="/attivita/modifica/:listId/:taskId" element={<ModificaAttivitaPage />} />

                                  {/* Rotte per l'editor di layout */}
                                  <Route path="/layouts" element={<LayoutList />} />
                                  <Route path="/layouts/new" element={<LayoutEditor />} />
                                  <Route path="/layouts/edit/:id" element={<LayoutEditor />} />

                                  {/* Rotta per Amministrazione */}
                                  <Route path="/amministrazione" element={<AdminPage />} />
                                  <Route path="/admin/layout/homepage" element={<GestioneHomepage />} />
                                  <Route path="/admin/users" element={<UserManagement />} />

                                  {/* Rotte per Integrazioni IBS */}
                                  <Route path="/integrazioni/ibs/ordini" element={<Navigate to="/ordini" replace />} />
                                  <Route path="/integrazioni/ibs/prodotti" element={<ProdottiIBS />} />
                                  <Route path="/integrazioni/ibs/messaggi" element={<IBSMessagesPage />} />
                                  <Route path="/integrazioni/ibs/errori-offerte" element={<ErroriOfferteIBS />} />
                                  <Route path="/integrazioni/ibs/reclami" element={<ReclamiIBS />} />
                                  <Route path="/integrazioni/ibs/ricarichi" element={<RicarichiIBSPage />} />
                                  <Route path="/integrazioni/ibs/repricing" element={<RepricingIBSPage />} />
                                  <Route path="/integrazioni/ibs/repricing-dashboard" element={<RepricingDashboardPage />} />
                                  <Route path="/integrazioni/ibs/pagamenti" element={<IBSPaymentsDashboard />} />
                                  <Route path="/integrazioni/ibs/notifiche-consegna" element={<OrdiniNotificheConsegna />} />

                                  {/* Rotte per la gestione dei template email */}
                                  <Route path="/email-templates" element={<EmailTemplateList />} />
                                  <Route path="/email-templates/new" element={<EmailTemplateEdit />} />
                                  <Route path="/email-templates/edit/:id" element={<EmailTemplateEdit />} />

                                  {/* Rotta per Email Schedulate */}
                                  <Route path="/email-schedulate" element={<EmailSchedulateManagement />} />

                                  {/* Rotte per Promozioni */}
                                  <Route path="/promozioni" element={<PromozioniList />} />
                                  <Route path="/promozioni/new" element={<PromozioneEdit />} />
                                  <Route path="/promozioni/edit/:id" element={<PromozioneEdit />} />

                                  {/* Rotte per Cataloghi PDF */}
                                  <Route path="/cataloghi" element={<CataloghiList />} />
                                  <Route path="/cataloghi/new" element={<CatalogoEdit />} />
                                  <Route path="/cataloghi/edit/:id" element={<CatalogoEdit />} />

                                  {/* Rotte per Copertine DVD */}
                                  <Route path="/copertine-dvd" element={<CopertineDvdList />} />
                                  <Route path="/copertine-dvd/:id" element={<CopertineDvdLotto />} />

                                  {/* Rotte per Codici Sconto */}
                                  <Route path="/codici-sconto" element={<CodiciScontoList />} />
                                  <Route path="/codici-sconto/new" element={<CodiciScontoEdit />} />
                                  <Route path="/codici-sconto/print" element={<CodiciScontoPrint />} />
                                  <Route path="/codici-sconto/omaggio/print" element={<CodiciOmaggioPrint />} />
                                  <Route path="/codici-sconto/:id" element={<CodiciScontoEdit />} />
                                  <Route path="/codici-sconto/:id/edit" element={<CodiciScontoEdit />} />
                                  <Route path="/codici-sconto/edit/:id" element={<CodiciScontoEdit />} />

                                  {/* Rotte per Punti Fedeltà */}
                                  <Route path="/punti-fedelta/config" element={<PuntiFedeltaConfig />} />
                                  <Route path="/punti-fedelta/gestione" element={<PuntiFedeltaManagement />} />

                                  {/* Rotte per Recensioni */}
                                  <Route path="/recensioni/gestione" element={<RecensioniManagement />} />

                                  {/* Rotte per Wishlist */}
                                  <Route path="/wishlist/gestione" element={<WishlistManagement />} />

                                  {/* Rotte per Valutazioni Servizio */}
                                  <Route path="/valutazioni-servizio/gestione" element={<ValutazioniServizioManagement />} />
                                  <Route path="/audit-logs" element={<AuditLogsPage />} />

                                  <Route path="/gestione-about" element={<GestioneAbout />} />
                                  <Route path="/riversamenti/contenuti" element={<ContenutiRiversamenti />} />
                              </Routes>
                          </ProtectedRoute>
                      } />
                  </Routes>
          </DashboardLayout>
          </SidebarProvider>
        </AuthProvider>
      </Router>
  );
}
